module.exports = __webpack_public_path__ + "static/media/ios-cloud-outline.28bee076.svg";